// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import Rails from "@rails/ujs";
import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
// import "../js/turbo_hack.js";
import "channels";
Rails.start();
ActiveStorage.start();
window.Rails = Rails;
import jquery from "jquery";
window.$ = window.jquery = jquery;

import "../js/bootstrap_js_files.js";
import "@fortawesome/fontawesome-free/css/all";
require("trix");
require("@rails/actiontext");
import "controllers";
import "select2";

document.addEventListener("turbo:load", function () {
  if ($("form")[0]) $("form")[0].reset();
  let elem = $(".form-submit");
  if ($(".form-submit")[0]) {
    Rails.enableElement($(".form-submit")[0]);
    elem.html(elem.data("originalMsg"));
  }
});

window.addEventListener("DOMContentLoaded", () => {
  $(".select2").select2({
    width: "resolve",
  });
  $('[data-bs-toggle="tooltip"]').tooltip({ html: true });
});
